import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDao } from '../../../core/services/dao/userDao';
import { ErrorDialogService } from '../../shared/errorDialog/errorDialogService';

@Component({
  selector: 'app-forgot-password',
  templateUrl: 'forgot-password.component.html'
})
export class ForgotPasswordComponent implements OnInit {
  public email: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userDao: UserDao,
    private dialog: ErrorDialogService
  ) {}

  ngOnInit() {}

  forgotPassword() {
    const url = window.location.origin + '/users/reset-password';
    const submitEmail = this.userDao.requestEmail(this.email, url);

    submitEmail.subscribe(res => {
      if (res === null) {
        this.dialog.open('Invalid', 'Credentials not found');
      } else {
        this.dialog.open('Email Sent', "Follow the email's instructions to reset your password.");
      }
    });
  }

  cancel() {
    this.router.navigate(['/login']);
  }
}
